import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ProjectSprintData } from '../../../core/modules/project/services/project.sprint.data.service';
import { TrackeritemRest } from './trackeritem.rest';

/**
 * Shared "how many children does this Tracker Item have, and how many are closed" data access
 * for #65237's Breakdown feature (BreakdownTabComponent and BreakdownHeaderComponent both need
 * it -- the header shows the progress bar on every tab, the Breakdown tab itself shows the
 * Remaining/Burndown charts). rel.children is fetched via its own resolve, not bundled into the
 * main trackeritem fetch, so both callers share this same on-demand load instead of duplicating
 * it.
 */
@Injectable()
export class TrackeritemBreakdownService {
  constructor(
    private projectSprintData: ProjectSprintData,
    private trackeritemRest: TrackeritemRest
  ) {}

  refreshChildren(trackeritem: any): Promise<void> {
    return this.trackeritemRest.getDetails(trackeritem.id, { rel: 'children' }).then((data: any) => {
      trackeritem.hasSubitems = data.hasSubitems;
      trackeritem.subitemsCount = data.subitemsCount;
      trackeritem.rel.children = _.get(data, 'rel.children', []);
      trackeritem.rel.remaining = _.get(data, 'rel.remaining', []);
      trackeritem.rel.burndown = _.get(data, 'rel.burndown', {});
    });
  }

  ensureChildrenLoaded(trackeritem: any): Promise<void> {
    if (!trackeritem?.hasSubitems) {
      return Promise.resolve();
    }
    if (trackeritem?.rel?.children) {
      return Promise.resolve();
    }
    return this.refreshChildren(trackeritem);
  }

  getSummary(trackeritem: any): any {
    const children = _.get(trackeritem, 'rel.children', []);
    const total = children.length;
    const closed = _.filter(children, (child) => child.statusId === 0).length;

    return {
      total: total,
      closed: closed,
      remaining: Math.max(total - closed, 0),
      percentComplete: this.projectSprintData.getCompletePercent(closed, total)
    };
  }

  progressBarClass(summary: any): string {
    return this.projectSprintData.getProgressBarClass(summary);
  }
}
